import { Container } from "@/components/LandingPage/Container";
import analytics from "@/utils/analytics/analytics";

import Link from "next/link";
import Aurora from "./Aurora";

export function Hero() {
  return (
    <Container className="relative overflow-hidden pb-16 pt-32 text-center sm:pb-32 md:pt-56">
      <div className="pointer-events-none absolute inset-x-[-20%] top-[-55%] bottom-[-35%] hidden opacity-80 lg:block">
        <Aurora
          colorStops={["#3A29FF", "#FF94B4", "#FF3232"]}
          blend={0.5}
          amplitude={1.0}
          speed={0.5}
        />
      </div>
      <div className="relative">
        <h1 className="mx-auto max-w-[50rem] font-display text-4xl font-bold gradient-text sm:text-6xl md:text-8xl">
          JSON Storage API for Developers
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-sm font-medium text-[#FAFAFA] sm:text-lg">
          Store, manage, and version your JSON data with our secure REST API.
          Perfect for prototyping, CMS, IoT applications, and web dashboards.
          No infrastructure setup required - just focus on building your app.
        </p>
        <div className="mx-auto mt-8 max-w-xl rounded-2xl border border-purple/40 bg-purple/10 px-6 py-5 shadow-[0_0_40px_-10px_rgba(111,48,255,0.45)] sm:px-8">
          <p className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            500 free credits
          </p>
          <p className="mt-2 text-sm text-gray-300 sm:text-base">
            No credit card. Start building in minutes. Every API call uses one
            credit.
          </p>
        </div>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row sm:gap-6">
          <Link
            href="/signup"
            className="rounded-3xl border-2 border-purple bg-purple px-8 py-3.5 text-center text-base font-bold text-white shadow-lg shadow-purple/25 transition-all duration-200 hover:scale-[1.02] hover:bg-purple/90 sm:min-w-[280px]"
            onClick={() => analytics.track("click_create_account")}
          >
            Get 500 free credits
          </Link>
          <button
            type="button"
            onClick={() => {
              document
                .getElementById("api-preview")
                ?.scrollIntoView({ behavior: "smooth" });
              analytics.track("click_api_preview_anchor");
            }}
            className="rounded-3xl border border-white/20 bg-white/5 px-8 py-3.5 text-center text-base font-bold text-white backdrop-blur-sm transition-all duration-200 hover:border-purple hover:bg-white/10 sm:min-w-[220px]"
          >
            See curl &amp; fetch
          </button>
        </div>
        <div className="mt-6">
          <button
            onClick={() => {
              document
                .getElementById("json-storage-section")
                ?.scrollIntoView({ behavior: "smooth" });
              analytics.track("click_quick_json_storage");
            }}
            className="text-sm font-medium text-purple underline transition-colors hover:text-purple/80"
          >
            Or try our quick JSON storage (no signup required)
          </button>
        </div>
        <div className="mt-8 text-sm text-gray-400">
          <p>
            <Link
              href="/#pricing"
              className="text-gray-300 underline decoration-gray-600 underline-offset-2 transition-colors hover:text-white"
            >
              Pay-as-you-go from $9
            </Link>
            {" · "}
            <span>Most teams pick 100k credits at $25</span>
          </p>
        </div>
      </div>
    </Container>
  );
}
